























    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import EditModel from './storeaddress-edit.vue'
    import CreateModel from './storeaddress-add.vue'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);

    class PageFreightRequest extends PageRequest {
    }

    @Component
        ({
            name: "backstoreaddress",
            components: { CreateModel, EditModel }
        })
    export default class backstoreaddress extends AbpBase {
        whetherStatus = Enums.getEnum(Enums.IsEffectiveStatus, true);
        siteType = Enums.getEnum(Enums.SiteSType, true);
        pagerequest: PageFreightRequest = new PageFreightRequest();
        isSuccess: boolean;
        creationTime: Date[] = [];
        editModalShow: boolean = false;
        createModalShow: boolean = false;
        get list() {
            return this.$store.state.backstoreaddress.list;
        };
        get loading() {
            return this.$store.state.backstoreaddress.loading;
        }
        async add() {
            this.createModalShow = true;
        }
        pageChange(page: number) {
            this.$store.commit('backstoreaddress/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('backstoreaddress/setPageSize', pagesize);
            this.getpage();
        }


        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters
            //if (this.creationTime.length > 0) {
            //    this.pagerequest.beginTime = this.creationTime[0];
            //}
            //if (this.creationTime.length > 1) {
            //    this.pagerequest.endTime = this.creationTime[1];
            //}

            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: this.pagerequest
            })
        }
        ShowModel(data: any) {
            this.$store.state.backstoreaddress.StoreAddresss = data;
            this.editModalShow = true;
        }
        async DeleteModel(data: any) {
            //this.$Modal.confirm({
            //    title: "删除", content: "是否确认删除此条数据？", onOk: async () => {
            //        this.isSuccess =  await this.$store.dispatch({
            //            type: 'backstoreaddress/Delete',
            //            data: { id: data.id }
            //        })
            //        //if (this.isSuccess == true) {
            //        //    this.getpage();
            //        //}


            //    }
            //});
            this.isSuccess = await this.$store.dispatch({
                type: 'backstoreaddress/Delete',
                data: { id: data.id }
            })
            if (this.isSuccess == true) {
                this.getpage();
            }
        }
        async updateStatus(data: any) {
            await this.$store.dispatch({
                type: 'backstoreaddress/EditStatus',
                data: { id: data.id }
            })
            this.getpage();
        }
        get pageSize() {
            return this.$store.state.backstoreaddress.pageSize;
        }
        get totalCount() {
            return this.$store.state.backstoreaddress.totalCount;
        }
        get currentPage() {
            return this.$store.state.backstoreaddress.currentPage;
        }
        columns = [
            //{
            //    type: 'selection',
            //    width: 50,
            //    align: 'center',
            //    fixed: 'left',
            //},
            {
                title: '仓储名称',
                key: 'storeName',
                width: 150,
                fixed: 'left',
            },
            {
                title: '站点',
                width: 120,
                key: 'site',
                render: (h: any, params: any) => {
                    return h('span', Enums.SiteSType.filter(function (item) { return item.value == params.row.site })[0].name);
                }
            },
            {
                title: '是否国内',
                key: 'whetherLocal',
                width: 90,
                render: (h: any, params: any) => {
                    return h('span', params.row.whetherLocal ? "是" : "否");
                }
            },
            {
                title: '是否有效',
                key: 'whetherEffective',
                width: 90,
                render: (h: any, params: any) => {
                    return h('span', params.row.whetherEffective ? "有效" : "无效");
                }
            },
            {
                title: '是否需要称重',
                key: 'whetherNeedWeighing',
                width: 110,
                render: (h: any, params: any) => {
                    return h('span', params.row.whetherNeedWeighing ? "是" : "否");
                }
            },
            {
                title: '仓储地址',
                width: 460,
                key: 'storeAddress',
            },
            {
                title: '联系人姓名',
                key: 'contactName',
                width: 150,
            }, {
                title: '联系电话',
                width: 150,
                key: 'contactPhone',
            },
            {
                title: '仓储备注',
                width: 350,
                key: 'remark',
            },
            {
                title: '操作',
                width: 300,
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var _this = this;
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '80px',
                                height: '30px',
                                display: params.row.whetherEffective == true ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {

                                    _this.ShowModel(params.row);
                                }
                            }

                        }, "修改"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                marginLeft: '5px',
                                width: '80px',
                                height: '30px',
                                display: params.row.whetherEffective == true ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                    _this.DeleteModel(params.row);
                                }
                            }

                        }, "删除"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                marginLeft: '5px',
                                width: '80px',
                                height: '30px',
                                display: params.row.whetherEffective == true ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                    _this.updateStatus(params.row);
                                }
                            }

                        }, "标为无效")
                    ]);
                }
            }
        ]
        async created() {
            this.getpage();
        }
    }
